import NavButton from '@atoms/NavButton/NavButton';
import HorizontalDirectionEnum from '@models/enums/HorizontalDirectionEnum';
import Carousel from '@molecules/Carousel/Carousel';
import classNames from 'classnames';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper } from 'swiper/types';

interface Props {
  readonly id: string;
  readonly hasMultipleItems: boolean;
  readonly enabledNavigationArrowColor?: string;
  readonly isTouchDevice?: boolean;
}

const NotificationCarousel = ({
  id,
  hasMultipleItems,
  isTouchDevice,
  enabledNavigationArrowColor,
  children,
}: PropsWithChildren<Props>) => {
  const [swiperInstance, setSwiperInstance] = useState<Swiper>();
  const isNavButtonHidden =
    !hasMultipleItems || isTouchDevice === undefined || isTouchDevice;

  useEffect(() => {
    if (!swiperInstance || isTouchDevice === undefined) return;
    swiperInstance.allowTouchMove = isTouchDevice;
  }, [isTouchDevice, swiperInstance]);

  return (
    <div className="flex min-h-[2.5rem] w-full">
      <div
        className={classNames('ml-7.5 self-center', {
          hidden: isNavButtonHidden,
        })}
      >
        <NavButton
          direction={HorizontalDirectionEnum.Left}
          id={id}
          hasBackgroundColor={false}
          sizeClassName="h-6 w-6"
          enabledArrowColor={enabledNavigationArrowColor}
        />
      </div>

      <Carousel
        loop
        className="w-full min-w-0"
        navId={id}
        id={id}
        additionalModules={[Autoplay]}
        autoplay={{
          delay: 5000,
        }}
        onSwiper={setSwiperInstance}
      >
        {children}
      </Carousel>

      <div
        className={classNames('mr-7.5 self-center', {
          hidden: isNavButtonHidden,
        })}
      >
        <NavButton
          direction={HorizontalDirectionEnum.Right}
          id={id}
          hasBackgroundColor={false}
          sizeClassName="h-6 w-6"
          enabledArrowColor={enabledNavigationArrowColor}
        />
      </div>
    </div>
  );
};

export default NotificationCarousel;
